import {useRef, useState} from "react"
import Text from "../../components/input/text";

import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {user_info} from "../../config/tips";
import Select from "../../components/input/select";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";
import {Eye, Info} from "react-feather";
import Email from "../../components/input/email";

import TabLabel from "../../components/tabLabel";
import Password from "../../components/input/password";
import {UseToken} from "../../hooks/UseToken";

const Form = (props) => {
    const {user, roles, accounts, errors, isReady, onSubmit} = props

    const token_data = UseToken()

    const formRef = useRef()
    const [activeTab, setActiveTab] = useState('')
    const infoTab = <TabLabel slug="info" label="Info" icon={<Info/>} errors={errors}/>
    const previewTab = <TabLabel slug="preview" label="Preview" icon={<Eye/>} errors={errors}/>

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            login  : {
                email     : FormData.get('email'),
                id_role   : FormData.get('id_role'),
                password  : FormData.get('password'),
                id_account: FormData.get('id_account'),
            },
            details: {
                first_name: FormData.get('first_name'),
                last_name : FormData.get('last_name'),
            }
        })
    }


    const handleTabClick = (ev) => {
        setActiveTab(ev)
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <Tabs defaultActiveKey="0" onTabClick={handleTabClick}>
                <TabPane forceRender={true} key={'info'} tabKey={'info'} tab={infoTab}>
                    <Alert
                        icon="info"
                        docsPath="/docs/users"
                        message={user_info}
                    />

                    <Text required
                        size="md"
                        name="first_name"
                        label="First Name"
                        isReady={isReady}
                        placeholder="Type first name..."
                        value={user?.details?.first_name}
                        error={errors && errors['details.first_name']}
                    />

                    <Text required
                        size="md"
                        name="last_name"
                        label="Last Name"
                        isReady={isReady}
                        placeholder="Type last name..."
                        value={user?.details?.last_name}
                        error={errors && errors['details.last_name']}
                    />

                    {token_data?.userInfo?.role?.slug === 'super-admin' && <Select required
                        size="md"
                        label="Account"
                        isReady={isReady}
                        name="id_account"
                        options={accounts}
                        value={user?.id_account?.$oid}
                        placeholder="Choose an account"
                        error={errors && errors['login.id_account']}
                    />}


                    {token_data?.userInfo?.role?.slug !== 'super-admin' &&
                        <input type="hidden" name="id_account" value={token_data?.userInfo?.id_account} />
                    }


                    <Select required
                        size="md"
                        isReady={isReady}
                        label="Role"
                        name="id_role"
                        options={roles}
                        value={user?.id_role?.$oid}
                        placeholder="Choose status"
                        error={errors && errors['login.id_role']}
                    />

                    <Email required
                        size="md"
                        name="email"
                        label="Email"
                        isReady={isReady}
                        placeholder="Type email..."
                        value={user?.email}
                        error={errors && errors['login.email']}
                    />

                    <Password required
                        size="md"
                        name="password"
                        label="Password"
                        isReady={isReady}
                        placeholder="Type a strong password..."
                        error={errors && errors['login.password']}
                    />

                </TabPane>

            </Tabs>

            {activeTab !== "preview" && <Button
                size="sm"
                color="primary"
                isReady={isReady}
                icon={user ? 'check' : 'plus'}
                label={user ? 'Update' : 'Create'}
            />}

        </form>
    )
}

export default Form